export default "__VITE_ASSET__e22a173a__"